import { useQuery } from '@apollo/client';
import {
  CURRENT_USER_QUERY,
  MY_IMS_ORGS_QUERY,
  MY_AEP_QUERY,
  AEP_BY_ID_QUERY,
  MY_LAUNCH_QUERY,
  DOCUMENT_QUERY,
  PROJECTS_BY_SANDBOX_QUERY,
  LAUNCH_BY_SANDBOX_QUERY,
  MY_ACS_QUERY,
  MY_THIRD_PARTY_PRODUCTS,
  CONFIGURATIONS_QUERY,
  MY_WORKSPACES_QUERY
} from './queries';
import { getEnvironment } from '../services/environment';

export const useCurrentUser = () => {
  const { loading, error, data } = useQuery(CURRENT_USER_QUERY, {
    variables: { environment: getEnvironment() }
  });
  return { loading, error, data };
};

export const useMyIMSOrgs = () => {
  return useQuery(MY_IMS_ORGS_QUERY);
};

export const useMyAEP = () => {
  const { loading, error, data } = useQuery(MY_AEP_QUERY);
  return { loading, error, data };
};

export const useAEP = (id, include) => {
  const { loading, error, data } = useQuery(AEP_BY_ID_QUERY, {
    variables: {
      id: id + '',
      streamingEndpoint: include?.streamingEndpoint || false,
      details: include?.details || false
    }
  });
  return { loading, error, data };
};

export const useMyACS = () => {
  const { loading, error, data } = useQuery(MY_ACS_QUERY);
  return { loading, error, data };
};

export const useMyLaunch = (orgID) => {
  const params = {};
  if (orgID) {
    params.variables = { orgID };
  }

  const { loading, error, data } = useQuery(MY_LAUNCH_QUERY, params);
  return { loading, error, data };
};

export const useProjectsBySandbox = (imsOrgID, sandboxName) => {
  const { loading, error, data } = useQuery(PROJECTS_BY_SANDBOX_QUERY, {
    variables: {
      imsOrgID,
      sandboxName
    }
  });
  return { loading, error, data };
};

export const useDocument = (path) => {
  const { loading, error, data } = useQuery(DOCUMENT_QUERY, {
    variables: { path }
  });
  return { loading, error, data };
};

export const useLaunchBySandbox = (sandboxId) => {
  const { loading, error, data } = useQuery(LAUNCH_BY_SANDBOX_QUERY, {
    variables: {
      sandboxId
    }
  });
  return { loading, error, data };
};

export const useMyThirdPartyProducts = () => {
  const { loading, error, data, refetch } = useQuery(MY_THIRD_PARTY_PRODUCTS);
  return { loading, error, data, refetch };
};

export const useConfigurations = (variables) => {
  const { loading, error, data, refetch } = useQuery(CONFIGURATIONS_QUERY, {
    variables
  });
  return { loading, error, data, refetch };
};

export const useMyWorkspaces = () => {
  const { loading, error, data } = useQuery(MY_WORKSPACES_QUERY);
  return { loading, error, data };
};
